import styles from "./Footer.module.sass";
import Icon from "colbi_web_ui/lib/components/Icon/Icon";

const Footer = () => {
    return (
        <div className={styles["container"]}>
            <Icon
                className={styles["footer-img"]}
                name="sovos-logo"
                style={{ width: 130, height: 30 }}
            />
            <p>© 2024 Sovos Compliance, LLC</p>
        </div>
    );
};

export default Footer;
